import React, { useState, useEffect } from "react";
import "./Blogs_Inner_Page.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import Common_Banner from "../../common/common-banner/Common_Banner";
import { useSelector, useDispatch } from "react-redux";
import { IDS } from "../../../utils/IDS";
import { useParams, useNavigate } from "react-router-dom";
import {
  GetAllBlogs,
  GetSingleBlog,
} from "../../../features/components/blogs/blog/Slice";

const Blogs_Inner_Page = () => {
  const blogData = [
    {
      id: 1,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },

    {
      id: 2,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },

    {
      id: 3,
      image: "/assets/images/home/our-blogs/img-1.png",
      category: "Data Engineering",
      title: "The Role of Data Engineering in Digital Transformation",
      date: "January 28, 2026",
      desc:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
    },
  ];

  const navigate = useNavigate();

  const { id } = useParams();
  const dispatch = useDispatch();

  const blog = useSelector((state) => state?.blogs?.blog?.single_blog);

  const blogs = useSelector((state) => state?.blogs?.blog?.all_blog);

  const minBlog = blogs.slice(0, 3);

  useEffect(() => {
    dispatch(GetSingleBlog(id));
    dispatch(GetAllBlogs());
  }, [dispatch, id]);

  return (
    <section className="Blog_Details_Page ">
      <Common_Banner
        title="Blogs"
        bannerImg="/assets/images/common-banner/blogs.png"
      />

      <div className="container">
        <div className="blog_details_section">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-7">
              <div className="blog_main">
                <h2 className="blog_main_title">
                  {/* How to Choose the Right Career Path After 10th */}
                  {blog?.name}
                </h2>
                <p className="post_date">
                  <span>
                    <FontAwesomeIcon
                      icon={faCalendar}
                      style={{ color: "#BFBFBF" }}
                    />
                  </span>{" "}
                  {""}
                  {/* January 28, 2026 */}
                  {blog?.createdAt &&
                    new Date(blog?.createdAt).toLocaleDateString("en-GB", {
                      month: "long",
                      day: "numeric",
                      year: "numeric",
                    })}
                </p>
<div className="blog_main_content_holder">

                <div className="blog_main_image_wrapper">
                  <img
                    src={IDS?.IMG_URL + blog?.image}
                    alt="blog"
                    className="blog_main_image"
                  />
                </div>

                <div className="blog_description">
                  <p className="blog_text">
                    {/* Contrary to popular belief, Lorem Ipsum is not simply random
                    text. It has roots in a piece of classical Latin literature
                    from 45 BC, making it over 2000 years old. Richard
                    McClintock, a Latin professor at Hampden-Sydney College in
                    Virginia, looked up one of the more obscure Latin words,
                    consectetur, from a Lorem Ipsum passage, and going through
                    the cites of the word in classical literature, discovered
                    the undoubtable source. Lorem Ipsum comes from sections
                    1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The
                    Extremes of Good and Evil) by Cicero, written in 45 BC. This
                    book is a treatise on the theory of ethics, very popular
                    during the Renaissance. The first line of Lorem Ipsum,
                    "Lorem ipsum dolor sit amet..", comes from a line in section
                    1.10.32. */}

                    {blog?.description?.replace(/<\/?[^>]+(>|$)/g, "") || ""}
                  </p>

                  {/* <h5 className="blog_title">Why this is so important</h5>
                  <p className="blog_text">
                    Contrary to popular belief, Lorem Ipsum is not simply random
                    text. It has roots in a piece of classical Latin literature
                    from 45 BC, making it over 2000 years old. Richard
                    McClintock, a Latin professor at Hampden-Sydney College in
                    Virginia
                  </p>

                  <h5 className="blog_title">Key points to remember</h5>
                  <p className="blog_text">
                    Freshers often wonder what they’ll actually learn before
                    getting started. Honestly, it’s normal to feel a bit unsure.
                    The courses don’t throw everything at you at once. You pick
                    up the fundamentals first and then go step by step. These
                    are some things you usually start with.
                  </p>

                  <ul>
                    <li className="blog_text">
                      Richard McClintock, a Latin professor at Hampden-Sydney
                      College in Virginia
                    </li>
                    <li className="blog_text">
                      Lorem Ipsum passage, and going through the cites of the
                      word
                    </li>
                    <li className="blog_text">
                      Richard McClintock, a Latin professor at Hampden-Sydney
                      College in Virginia
                    </li>
                    <li className="blog_text">
                      Lorem Ipsum passage, and going through the cites of the
                      word
                    </li>
                  </ul>

                  <p className="blog_text">
                    Contrary to popular belief, Lorem Ipsum is not simply random
                    text. It has roots in a piece of classical Latin literature
                    from 45 BC, making it over 2000 years old. Richard
                    McClintock, a Latin professor at Hampden-Sydney College in
                    Virginia
                  </p> */}
                </div>
</div>
              </div>
            </div>

            <div className="col-lg-3 col-md-5 ">
              <div className="recent_blog_sidebar">
                <h5 className="recent_title">
                  Recent <span>Blogs</span>{" "}
                </h5>
                <div className="recent_blog_list">
                  {minBlog?.map((post) => (
                    <div key={post.id}>
                      <div className="blog_card card">
                        <div className="card-body p-0">
                          <img
                            src={IDS?.IMG_URL + post?.image}
                            alt={post?.category}
                            className="card_img"
                          />

                          <div className="category_title">
                            <h5 className="post_title">{post?.name}</h5>
                            <p className="post_date">
                              <span>
                                <FontAwesomeIcon
                                  icon={faCalendar}
                                  style={{ color: "#BFBFBF" }}
                                />
                              </span>{" "}
                              {post?.createdAt
                                ? new Date(post?.createdAt).toLocaleDateString(
                                    "en-GB",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    },
                                  )
                                : "N/A"}
                            </p>
                          </div>

                          <p className="post_desc">
                            {post?.description.replace(/<\/?[^>]+(>|$)/g, "") ||
                              ""}
                          </p>
                        </div>

                        <div className="card-footer p-0">
                          <div className="read_more_div">
                            <button
                              onClick={() => navigate(`/blog/${post?.id}`)}
                              className="read_more_btn"
                            >
                              Read More
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blogs_Inner_Page;
